// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FD_5X","totalItemWrap":"TxVLA","title":"jvGfx","amount":"_2stZt","borderTop":"_1do3b","strong":"_1UdZo"};